function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 24C18.5647 24 24 18.5529 24 12C24 5.43529 18.5529 0 11.9882 0C5.43529 0 0 5.43529 0 12C0 18.5529 5.44706 24 12 24ZM12 22C6.44706 22 2.01176 17.5529 2.01176 12C2.01176 6.44706 6.43529 2 11.9882 2C17.5412 2 21.9882 6.44706 22 12C22.0118 17.5529 17.5529 22 12 22ZM7.51765 12.9882H11V16.4941C11 17.0824 11.4 17.4824 11.9765 17.4824C12.5647 17.4824 12.9765 17.0824 12.9765 16.4941V12.9882H16.4824C17.0706 12.9882 17.4706 12.5882 17.4706 12.0118C17.4706 11.4235 17.0706 11.0118 16.4824 11.0118H12.9765V7.52941C12.9765 6.91765 12.5647 6.51765 11.9765 6.51765C11.4 6.51765 11 6.92941 11 7.52941V11.0118H7.51765C6.90588 11.0118 6.50588 11.4235 6.50588 12.0118C6.50588 12.5882 6.91765 12.9882 7.51765 12.9882Z",
  fill: "current"
});

function SvgAddCircleLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleLine);
export default __webpack_public_path__ + "static/media/add-circle-line.23fa19a9.svg";
export { ForwardRef as ReactComponent };